import React from "react";
export default class FieldForce extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "field-force-page" }));
    }
}
